import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, useResponsive } from '@common-fe/common-fe';

import { Modal } from '@/components';
import theme from '@/styles/theme';

import { CombinedAccountData } from '../../AccountDetails.types';
import AccountsList from '../AccountsList/AccountsList';

interface Props {
  accountsData?: CombinedAccountData[];
  onSetVisible: (value: boolean) => void;
}

const AccountDetailsPopup: React.FC<Props> = ({ accountsData, onSetVisible }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Modal
      testId="account-details"
      visible
      onSetVisible={onSetVisible}
      {...isMobile ? {
        contentStyle: {
          margin: theme.spacings.spacing16,
          borderRadius: theme.rounds.moduleRound,
        }
      } : {}}
    >
      <Text weight={700} size="2xl" textAlign="center">
        {t('Account Details')}
      </Text>

      <Box margin={{ top: 'spacing24' }}>
        <AccountsList accountsData={accountsData} />
      </Box>
    </Modal>
  );
};

export default AccountDetailsPopup;
